import { z } from "zod";

/**
 * Looser than the generated VideoUpload schema. Sorting by Status brings rows whose
 * `status` / `lastEvent` / `providerMetadata` the generated client still rejects
 * (VIDEO_DELETED, CANCELLED, object or empty-array providerMetadata), so a 200 never reaches the table.
 */
export const videoUploadRowSchema = z
	.object({
		id: z.number().int(),
		name: z.string(),
		file: z.string(),
		size: z.string().nullish(),
		duration: z.string().nullish(),
		bitRate: z.string().nullish(),
		width: z.number().int().nullish(),
		height: z.number().int().nullish(),
		status: z.string(),
		lastEvent: z.string().nullish(),
		message: z.string().nullish(),
		context: z.string().nullish(),
		provider: z.string().nullish(),
		origin: z.string().nullish(),
		apiStatus: z.string().nullish(),
		// Empty PHP arrays JSON-encode as `[]`, which is neither a string nor a record.
		providerMetadata: z.preprocess(
			(value: unknown) => (Array.isArray(value) ? {} : value),
			z.union([z.string(), z.record(z.unknown())]).nullish(),
		),
		metadata: z.string().nullish(),
		createdAt: z.string(),
		updatedAt: z.string().nullish(),
		backupStartedAt: z.string().nullish(),
		backupFinishedAt: z.string().nullish(),
		partialUploadStartedAt: z.string().nullish(),
		partialUploadFinishedAt: z.string().nullish(),
		uploadStartedAt: z.string().nullish(),
		uploadFinishedAt: z.string().nullish(),
		processingStartedAt: z.string().nullish(),
		processingFinishedAt: z.string().nullish(),
		metadataApprovedAt: z.string().nullish(),
		deletedAt: z.string().nullish(),
		deletedBy: z.string().nullish(),
		lastUpdatedBy: z.string().nullish(),
		metadataAddedBy: z.string().nullish(),
		uploadedBy: z.string().nullish(),
		approvedBy: z.string().nullish(),
		node: z.string().nullish(),
		gpuId: z.number().int().nullish(),
		workerId: z.number().int().nullish(),
	})
	.passthrough();

export const videoUploadsPageSchema = z.object({
	videos: z.array(videoUploadRowSchema),
	limit: z.number().int(),
	page: z.number().int(),
	pages: z.number().int(),
	total: z.number().int(),
});

export type VideoUploadsPage = z.infer<typeof videoUploadsPageSchema>;
